import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { AuthService } from "./../../auth.service";
import { Subscription } from "rxjs/Subscription";
import { AccountService } from "./../../../account/account.service";
import * as firebase from "firebase/app";
import { BackendService } from "../../backend.service";
import { ActivatedRoute, Router } from "@angular/router";

@Directive({
  selector: "[appCanAccess]"
})
export class CanAccessDirective implements OnInit, OnDestroy {
  @Input("appCanAccess") appCanAccess: string;
  private authState: firebase.User | null;
  private userId: string;
  private roleSubscription: Subscription;
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private accountService: AccountService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.authState = this.authService.getAuthState();
    this.userId = BackendService.generateUserId(this.authState.email);
  }

  /**
   * @description Angular on init function
   * @returns void
   */
  ngOnInit(): void {
    this.roleSubscription = this.accountService.getProfile(this.userId).subscribe((profile: any) => {
      this.route.params.subscribe(params => {
        if (profile.roles.length > 0) {
        const activeRole: any = profile.roles[params.index];
        this.applyPermission(activeRole.role);
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.roleSubscription.unsubscribe();
  }

  /**
   *
   * @param {string} role
   */
  private applyPermission(role: string): void {
    const authorized = role.toLowerCase() === this.appCanAccess.toLowerCase();
    if (authorized) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/permission/directive/can-access.directive.ts